import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks/redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentStaffUser } from 'store/slices/staff-user/staff-user-slice';

interface Props {
    children?: React.ReactNode;
}

export const UnAuthorized = (props: Props) => {
    const { children } = props;
    const currentStaffUser = useAppSelector(selectCurrentStaffUser);

    const [signedIn, setSignedIn] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (currentStaffUser) {
            if (currentStaffUser?.status === 'active') {
                navigate('/cards-sphere/sphere');
            } else {
                navigate('/');
            }
        }

        setSignedIn(!!currentStaffUser);
    }, [currentStaffUser]);

    return <>{!signedIn && children}</>;
};
